import { render, staticRenderFns } from "./add-button.vue?vue&type=template&id=a46b4198&scoped=true&"
import script from "./add-button.vue?vue&type=script&lang=js&"
export * from "./add-button.vue?vue&type=script&lang=js&"
import style0 from "./add-button.vue?vue&type=style&index=0&id=a46b4198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46b4198",
  null
  
)

export default component.exports